<template>
  <fieldset class="form-section" :disabled="disabled">
    <legend class="form-section__legend">
      <span class="form-section__title">{{ title }}</span>
      <span v-if="description" class="form-section__description">{{ description }}</span>
    </legend>
    <div class="form-section__body">
      <slot />
    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'FormSection',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.form-section {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.form-section + .form-section {
  margin-top: var(--sid-space-6);
  padding-top: var(--sid-space-6);
  border-top: 1px solid var(--sid-color-line);
}

.form-section__legend {
  display: block;
  width: 100%;
  margin: 0 0 var(--sid-space-4);
  padding: 0;
}

.form-section__title,
.form-section__description {
  display: block;
}

.form-section__title {
  font-size: var(--sid-font-size-section);
  font-weight: var(--sid-font-weight-semibold);
  line-height: var(--sid-line-height-section);
}

.form-section__description {
  max-width: 48rem;
  margin-top: var(--sid-space-1);
  color: var(--sid-color-text-secondary);
  font-size: var(--sid-font-size-body);
  font-weight: var(--sid-font-weight-regular);
  line-height: var(--sid-line-height-body);
}

.form-section__body {
  min-width: 0;
}

.form-section :deep(.q-field) {
  margin: 0;
}

.form-section :deep(.q-field__bottom) {
  min-height: var(--sid-space-5);
  padding: var(--sid-space-1) var(--sid-space-3) 0;
}

.form-section :deep(.q-field--disabled),
.form-section :deep(.q-toggle.disabled) {
  opacity: 0.68;
}

.form-section :deep(.q-field--readonly .q-field__control) {
  background: var(--sid-color-surface-subtle);
}
</style>
